<section class="time-filter-wrap mb-3">
    <!-- <div class="section-title">Filter</div> -->

    <!-- <div class="events-filter-wrap box">
        <div class="flex">
            <div class="item" [class.selected]="eventsTimeLeagueFilter" (click)="eventsTimeLeagueFilterChange(true)">Time</div>
            <div class="item" [class.selected]="!eventsTimeLeagueFilter" (click)="eventsTimeLeagueFilterChange(false)">League</div>
        </div>
    </div> -->

    <div class="time-filter box" *ngIf="pageType != pageTypeEnum.Live">
        <div class="time-option-wrap">
            <div class="time-option d-none" [class.selected]="timeFilterValue == timeFilterValueEnum.H1" (click)="timeFilterValueChange(timeFilterValueEnum.H1)">1h</div>
            <div class="time-option d-none" [class.selected]="timeFilterValue == timeFilterValueEnum.H3" (click)="timeFilterValueChange(timeFilterValueEnum.H3)">3h</div>
            <div class="time-option" [class.selected]="timeFilterValue == timeFilterValueEnum.H6" (click)="timeFilterValueChange(timeFilterValueEnum.H6)">6h</div>
            <div class="time-option" [class.selected]="timeFilterValue == timeFilterValueEnum.H12" (click)="timeFilterValueChange(timeFilterValueEnum.H12)">12h</div>
            <div class="time-option" [class.selected]="timeFilterValue == timeFilterValueEnum.H24" (click)="timeFilterValueChange(timeFilterValueEnum.H24)">24h</div>

            <div class="time-option" [class.selected]="timeFilterValue == timeFilterValueEnum.D1" (click)="timeFilterValueChange(timeFilterValueEnum.D1)">
                <span>{{D1 | date:'dd.MM.'}}</span>
            </div>
            <div class="time-option" [class.selected]="timeFilterValue == timeFilterValueEnum.D2" (click)="timeFilterValueChange(timeFilterValueEnum.D2)">
                <span>{{D2 | date:'dd.MM.'}}</span>
            </div>
            <div class="time-option d-none" [class.selected]="timeFilterValue == timeFilterValueEnum.D3" (click)="timeFilterValueChange(timeFilterValueEnum.D3)">
                <span>{{D3 | date:'dd.MM.'}}</span>
            </div>
            <div class="time-option d-none" [class.selected]="timeFilterValue == timeFilterValueEnum.D4" (click)="timeFilterValueChange(timeFilterValueEnum.D4)">
                <span>{{D4 | date:'dd.MM.'}}</span>
            </div>
            <div class="time-option d-none" [class.selected]="timeFilterValue == timeFilterValueEnum.D5" (click)="timeFilterValueChange(timeFilterValueEnum.D5)">
                <span>{{D5 | date:'dd.MM.'}}</span>
            </div>
            <span class="time-option" [class.selected]="timeFilterValue == timeFilterValueEnum.All" (click)="timeFilterValueChange(timeFilterValueEnum.All)">ALL</span>
        </div>
    </div>

    <!-- <app-search></app-search> -->


</section>
